'use client';

import { Button, CircularProgress, Divider, Grid, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { InverseButton } from '@parkchirp/ui-library';
import React, { useState } from 'react';

interface Props {
	title: string | null;
	handleDismiss: () => void;
	handleConfirm: () => void;
	validationString: string | null;
	confirmText: string | null;
	dismissText: string | null;
}

export const ConfirmationInputModal = ({
	title,
	handleDismiss,
	handleConfirm,
	validationString,
	confirmText,
	dismissText,
}: Props): React.JSX.Element => {
	const [validationInput, setValidationInput] = useState<string>('');
	const [clicked, setClicked] = useState<boolean>(false);
	const theme = useTheme();

	return (
		<div>
			<Typography data-cy='modal-title-text' fontWeight='bold' variant='h6'>
				{title}
			</Typography>
			<Divider variant='middle' />
			<br />
			<div style={{ display: 'flex', flexDirection: 'column' }}>
				<p data-cy='modal-body-text'>Please type {validationString} below to confirm</p>
				<TextField
					type='text'
					value={validationInput}
					onChange={(e) => setValidationInput(e.target.value)}
					placeholder={validationString}
					inputProps={{ 'data-cy': 'modal-input' }}
				/>
			</div>

			<Grid className='pca__ratesForm-containerPadding' spacing={2} container>
				<Grid item xs={6}>
					<InverseButton
						fullWidth
						onClick={handleDismiss}
						data-cy='modal-cancel-button'
						name={dismissText}
						theme={theme}
					/>
				</Grid>
				<Grid item xs={6}>
					<Button
						fullWidth
						onClick={() => {
							setClicked(true);
							handleConfirm();
						}}
						disabled={validationInput !== validationString || clicked}
						data-cy='modal-confirm-button'
					>
						{confirmText}
						{clicked && <CircularProgress style={{ height: '20px', width: '20px' }} />}
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};
